type CustomerSupportRequestFormProps = {
  sectionTitle: string
  subjectLabel: string
  subjectPlaceholder: string
  messageLabel: string
  messagePlaceholder: string
  orderIdLabel: string
  orderIdPlaceholder: string
  submitLabel: string
  submittingLabel: string
  supportSubject: string
  supportMessage: string
  supportOrderId: string
  supportSubmitting: boolean
  supportSuccess: string
  onSupportSubjectChange: (value: string) => void
  onSupportMessageChange: (value: string) => void
  onSupportOrderIdChange: (value: string) => void
  onSubmitSupportRequest: () => void
}

export const CustomerSupportRequestForm = ({
  sectionTitle,
  subjectLabel,
  subjectPlaceholder,
  messageLabel,
  messagePlaceholder,
  orderIdLabel,
  orderIdPlaceholder,
  submitLabel,
  submittingLabel,
  supportSubject,
  supportMessage,
  supportOrderId,
  supportSubmitting,
  supportSuccess,
  onSupportSubjectChange,
  onSupportMessageChange,
  onSupportOrderIdChange,
  onSubmitSupportRequest,
}: CustomerSupportRequestFormProps) => (
  <section className="ca-card-shell ca-theme-transition rounded-3xl p-5">
    <h2 className="text-sm font-semibold uppercase tracking-[0.16em] text-(--color-text-muted)">{sectionTitle}</h2>
    <form
      className="mt-4 space-y-3"
      onSubmit={(event) => {
        event.preventDefault()
        onSubmitSupportRequest()
      }}
    >
      <label className="grid gap-1 text-sm font-medium text-(--color-text-secondary)">
        {subjectLabel}
        <input
          value={supportSubject}
          onChange={(event) => onSupportSubjectChange(event.target.value)}
          placeholder={subjectPlaceholder}
          required
          minLength={3}
          maxLength={180}
          className="ca-input h-10 px-3 text-sm"
        />
      </label>

      <label className="grid gap-1 text-sm font-medium text-(--color-text-secondary)">
        {orderIdLabel}
        <input
          value={supportOrderId}
          onChange={(event) => onSupportOrderIdChange(event.target.value)}
          placeholder={orderIdPlaceholder}
          className="ca-input h-10 px-3 text-sm"
        />
      </label>

      <label className="grid gap-1 text-sm font-medium text-(--color-text-secondary)">
        {messageLabel}
        <textarea
          value={supportMessage}
          onChange={(event) => onSupportMessageChange(event.target.value)}
          placeholder={messagePlaceholder}
          required
          minLength={10}
          maxLength={5000}
          rows={5}
          className="ca-input px-3 py-2 text-sm"
        />
      </label>

      <div className="flex flex-wrap items-center gap-2">
        <button
          type="submit"
          disabled={supportSubmitting}
          className="ca-btn-primary inline-flex h-9 items-center px-4 text-sm font-semibold disabled:cursor-not-allowed disabled:opacity-60"
        >
          {supportSubmitting ? submittingLabel : submitLabel}
        </button>
        {supportSuccess ? (
          <span className="text-sm font-medium text-(--color-status-success)">{supportSuccess}</span>
        ) : null}
      </div>
    </form>
  </section>
)
